import { type AxiosError } from 'axios'
import { useMutation, type UseMutationOptions } from 'react-query'

import agent from 'agent'
import useAuth from 'hooks/use-auth'
import { getEndpointWithParams } from 'queries/queries-utils'
import { statusChecksMutationKeys } from 'queries/status-checks/query-keys'

import type {
  DynatraceStatusCheckCreateRequest,
  DynatraceStatusCheckCreateResponse
} from 'types/api/status-checks/status-check'

function createDynatraceStatusCheck({
  mutationKey
}: {
  mutationKey: ReturnType<
    typeof statusChecksMutationKeys.createDynatraceStatusCheck
  >
}) {
  return async function (params: DynatraceStatusCheckCreateRequest) {
    const endpointWithParams = getEndpointWithParams(...mutationKey)
    const result = await agent.post<DynatraceStatusCheckCreateResponse>(
      endpointWithParams,
      params
    )
    return result.data
  }
}

export function useCreateDynatraceStatusCheck(
  options?: Omit<
    UseMutationOptions<
      DynatraceStatusCheckCreateResponse,
      AxiosError,
      DynatraceStatusCheckCreateRequest
    >,
    'queryFn' | 'queryKey'
  >
) {
  const { currentTeamId: teamId } = useAuth()
  const mutationKey = statusChecksMutationKeys.createDynatraceStatusCheck({
    teamId
  })

  return useMutation({
    ...options,
    mutationKey,
    mutationFn: createDynatraceStatusCheck({ mutationKey })
  })
}
